import React from 'react';
import { VendorCtaSelectorProps } from './VendorCtaSelector';

const UpstartCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  return (
    // eslint-disable-next-line
    <div
      className="prodigy-pricing-button-group"
      data-vin={vin}
      data-config-type={ctaDetails.configTypeLocationUpstart?.toUpperCase()}
      data-testid="upstart"
    ></div>
  );
};

export default UpstartCta;
